module.exports = __webpack_public_path__ + "static/media/live_data_vital_sign_warning.c6117aa1.wav";